import { confirm } from "@verbleif/lib/src/composables/Dialog/confirm";
import i18n from "@verbleif/lib/src/translations/i18n";

const TRANSLATION_KEY = "navbar.dropdown";

/** Asks to sign out of every account of this browser; resolves true when the person confirms. */
export function confirmLogoutAll(): Promise<boolean> {
  const { t } = i18n.global;
  return confirm({
    title: t(`${TRANSLATION_KEY}.logout_all_accounts_question`),
    message: t(`${TRANSLATION_KEY}.logout_all_hint`),
    variant: "danger",
    confirmText: t(`${TRANSLATION_KEY}.logout`),
    cancelText: t("base.cancel"),
  });
}
